export default function IosReverseCameraOutline() {
  return (
    <div
      className="ion-icon-ios-reverse-camera-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M301.815,318.608c-13.114,11.029-28.956,17.356-45.815,17.356c-36.36,0-66.286-28.965-70.89-61.965h30.61l-38.87-50
		l-37.534,50h29.479c4.696,42,41.717,78,87.205,78c20.9,0,41.17-7.566,57.076-21.218l2.37-2.159l-11.599-11.662L301.815,318.608z"/>
	<path d="M315.736,198.885c-16.188-14.775-37.402-22.839-59.736-22.839c-20.9,0-41.169,7.556-57.075,21.206l-2.371,2.052
		l11.599,11.61l2.033-1.706c12.927-10.872,29.197-17.005,45.814-17.005c36.343,0,66.274,28.797,70.891,63.797h-30.644l38.846,51.225
		L372.719,256h-29.512C340.966,236,331.275,213.064,315.736,198.885z"/>
	<path d="M417.5,160h-61.725c-32.105-36-42.219-48-54.525-48h-88.5c-12.314,0-22.167,12-54.521,48H145v-16h-34v16H97.5
		C79.855,160,64,173.217,64,190.684v176.018C64,384.169,79.855,400,97.5,400h320c17.645,0,30.5-15.831,30.5-33.299V190.684
		C448,173.217,435.145,160,417.5,160z M432,366.701c0,9.263-6.229,17.299-14.5,17.299h-320c-8.738,0-17.5-8.664-17.5-17.299V190.684
		C80,182.518,88.126,176,97.5,176h60.729c0,0,4.124,0,6.133,0s3.225-0.199,5.768-3.2s7.702-10.008,11.08-13.795
		c11.296-12.666,19.457-21.915,25.316-27.132c4.746-4.225,6.211-3.873,6.225-3.873h88.5c0.016,0,1.611-0.363,6.709,4.219
		c6.141,5.521,14.705,16.84,26.558,30.198c2.888,3.255,7.214,8.11,9.317,10.44s4.252,3.143,5.771,3.143s6.17,0,6.17,0H417.5
		c8.832,0,14.5,5.965,14.5,14.684V366.701z"/>
</g>
</svg>
`,
      }}
    />
  )
}
